import { render, staticRenderFns } from "./PlanDetail.vue?vue&type=template&id=2faa9e1b&scoped=true"
import script from "./PlanDetail.vue?vue&type=script&lang=js"
export * from "./PlanDetail.vue?vue&type=script&lang=js"
import style0 from "./PlanDetail.vue?vue&type=style&index=0&id=2faa9e1b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faa9e1b",
  null
  
)

export default component.exports